import React, { useState, useEffect, useRef } from 'react';
import HawaiiMapLoader from "@didi/hawaii-map-loader";

import { Spin } from 'antd';
import './index.css';

type PropsType = {
  value?: any;
  plugins?: any;
  onChange?: any;
  disabled?: any;
};

interface IMApCallback {
  style?: any;
  hawaiiMapApi: any;
  hawaiiMapPlugin: any;
}

const SPMap: React.FC<PropsType>  = (props) => {
  const { onChange, plugins, value, disabled } = props;
  
  const mapContainerRef = useRef(null);

  const [loadingMap, setLoadingMap] = useState<boolean>(true);

  const hMap = useRef(null);

  const poiSearchRef = useRef<any>(null);

  useEffect(() => {
    console.log(mapContainerRef.current);
    HawaiiMapLoader
    .load({
      appKey: "car-rental",
      plugins: plugins || [],
    })
    .then(({ style, hawaiiMapApi, hawaiiMapPlugin }:IMApCallback ) => {
      // 初始化地图实例
      console.log(style, '====');
      
      const map = new hawaiiMapApi.Map({
        container: mapContainerRef.current, // 容器ID
        style: style
      })
      hMap.current = map;
      map.getCanvas().style.cursor = "auto"

      // map on load 事件完成后：此时可以往地图上添加图层
      let targetMarker: any = null;
      map.on("load", () => {
        setLoadingMap(false);
        const searchWrapper = document.createElement("div");
        searchWrapper.setAttribute(
          "style",
          "position: absolute;left: 15px;top: 15px;z-index:99; display: flex; max-width: 60%;"
        )
        if (hawaiiMapPlugin && hawaiiMapPlugin.CitySelect) {
          const citySelectContainer = document.createElement("div")
          citySelectContainer.id = "city-select-container"
          searchWrapper.appendChild(citySelectContainer);
          citySelectContainer.setAttribute(
            "style",
            "margin-right: 12px; padding: 7px 15px; background: #fff;box-shadow: 0 0 12px rgba(0, 0, 0, 0.25);border-radius: 2px;height: 35px;white-space: nowrap;"
          )
          map.getContainer().appendChild(searchWrapper);
          const citySelect = new hawaiiMapPlugin.CitySelect({
            anchor: "bottom-left"
          })
          // 挂载指定节点
          citySelect.mount("city-select-container");
          // 监听城市点击事件
          citySelect.on("city-click", (pos: any) => {
            map.setCenter(pos, { zoom: 14 });
          });
        }
        if (hawaiiMapPlugin && hawaiiMapPlugin.PoiSearch) {
          const poiSearch = new hawaiiMapPlugin.PoiSearch(map, {
            autoCollapsePanel: true,
            panelMaxHeight: 400
          })
          const poiSearchContainer = document.createElement("div")
          poiSearchContainer.id = "poi-search-container"
          // poiSearchContainer.setAttribute(
          //   "style",
          //   "position: absolute;left: 15px;top: 15px;z-index:99;width: 300px;"
          // )
          searchWrapper.appendChild(poiSearchContainer)
          // map.getContainer().appendChild(poiSearchContainer)
          if (!document.getElementById('poi-search-container')) return;
          poiSearch.mount("poi-search-container")
          poiSearch.on("poi-click", (poiInfo: any) => {
            const { city_id, lat, lng } = poiInfo?.base_info || {};
            onChange({ city_id, lat, lng });
            targetMarker?.remove();
          })
          poiSearchRef.current = poiSearch;
        }
      });
      
      map.on("click", async (pos: any) => {
        const { lngLat } = pos || {};
        const div = document.createElement("div")
        const marker = new hawaiiMapApi.Marker({
          // draggable: true,
          // rotation: 0,
          element: div,
          rotationAlignment: 'auto',
          pitchAlignment: 'auto'
         })
        //  marker.setLngLat([lngLat.lng, lngLat.lat])
        //  marker.addTo(map)
         
        const poiService = new hawaiiMapApi.PoiService()
        const [err, res] = await poiService.reverseGeo({
          select_lng: lngLat.lng,
          select_lat: lngLat.lat,
        })
        if (!err) {
          const { city_id, result } = res || {};
          const address = result[0]?.base_info?.address;
          const searchInput: any = document.querySelector('.hawaii-map-plugin__poi-search-container .input-area input');
          if (searchInput) {
            searchInput.value = address;
          }
          onChange({ city_id: +city_id, lat: lngLat.lat, lng: lngLat.lng });
        } else {

        }
        if (targetMarker) {
          targetMarker.setLngLat([lngLat.lng, lngLat.lat]);
        } else {
          marker.setLngLat([lngLat.lng, lngLat.lat])
          targetMarker = marker;
          marker.addTo(map)
        }
      })
    });
  }, []);


  useEffect(() => {
    if (value && plugins.includes('PoiSearch') && poiSearchRef.current) {
      const { lat, lng } = value;
      
      poiSearchRef.current?.setQuery("", {
        // 同时绘制 icon
        withSymbol: {
          geoData: [lng, lat],
          // popupContent: { a: 1 },
          // poiStyle: {
          //   symbolIconImage:
          //     "https://img-ys011.didistatic.com/static/map_webapp/do1_ZeCaUZTf8txV78gLCaS8"
          // }
        },
        triggerSearch: false // 是否触发请求
      })
    }
  }, [value, poiSearchRef.current])

  const maskStyle: any = {
    zIndex: 100,
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    pointerEvents: 'none',
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
    opacity: 0.2,
  }

  return (
    <Spin size="large" spinning={loadingMap}>
      <div style={{ position: 'relative', borderRadius: 6, border: '1px solid rgba(0, 0, 0, 0.15)', padding: 16 }} className="yks-map">
        <div ref={mapContainerRef} style={{ height: 320, borderRadius: 6 }}></div>
        {disabled && <div style={maskStyle}></div>}
      </div>
    </Spin>
  )
}

export default SPMap;